<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth <= 768" />
		<b-container fluid>
			<img class="top_img" style="cursor: pointer;" width="100%" src="../../static/img/media/top_img.png"
				@click="gotoPage" />
			<img class="top_img1" style="cursor: pointer;" width="100%" src="../../static/img/media/top_img1.png"
				@click="gotoPage" />
		</b-container>
		<div class="mianbao" toggleable="lg">
			<div class="mianbao_view">
				<div v-for="(item, index) in mianbaoList" :key="index" class="mianbao_item" :class="{ active: index == i }"
					@click="goAnchor(item.id, index)">{{ item.label }}</div>
			</div>
		</div>
		<div class="mianbao_min">
			<div v-for="(item, index) in mianbaoList" style="margin-right:15px" :key="index" :class="{ active: index == i }"
				@click="goAnchor(item.id, index)">{{ item.label }}</div>
		</div>
		<div class="media_state border-bottom padding-bottom" id="title1" v-if="windowWidth > 768">
			<div class="title_img">
				<h4 class="text-left">图文展示</h4>
			</div>
			<div class="state_view1">
				<div class="media_view_1" v-for="(item, index) in newsList" :key="index" @click="gotoNews(item.Id)"
					v-if="index == 0">
					<div class="media_left">
						<img width="1080" height="520" :src="splitImg(item.Cover)" />
					</div>
					<div class="media_right_1" style="background-color: #fff; padding:  40px;">
						<p class="text_title" style="color:#0C8C69;font-weight:bold;font-size: 30px;text-align: left;">{{
							item.Title }}</p>
						<p class="text_view" style="color:#222;font-size:16px;text-align: left;">{{ item.Description }}</p>
					</div>
				</div>
			</div>
			<div class="state_view2">
				<div class="state_right">
					<div class="media_view" v-for="(item, index) in newsList" :key="index" @click="gotoNews(item.Id)"
						v-if="0 < index && index < 6">
						<div class="media_right" style="padding: 40px 0 0 40px;">
							<p class="text_title text_title1" style="color:#222;font-size: 24px;">{{ item.Title }}</p>
							<p style="font-size: 14px;color: #222;">{{ formatDate(item.ReleaseDate) }}</p>
							<p class="text_view text_view1" style="color:#222;font-size:16px;">{{ item.Description }}</p>

						</div>
						<div class="media_left">
							<img width="450" height="285" :src="splitImg(item.Cover)" />
						</div>
					</div>
				</div>
			</div>
			<router-link to='/moreNews' class="more_btn2">
				<div style="color:#222;margin-top:40px;font-size:24px;cursor: pointer;text-align: center;">查看更多 <img
						width="18" height="20" src="../../static/img/media/next.png" /></div>
			</router-link>
		</div>

		<div class="media_state border-bottom padding-bottom" id="title1" v-else>
			<div class="state_right">
				<div class="margin-top-sm" v-for="(item, index) in newsList" :key="index" @click="gotoNews(item.Id)"
					v-if="0 < index && index < 6">
					<img width="98%" height="190" :src="splitImg(item.Cover)" />
					<div class="media_right" style="background-color: #fff; padding:15px">
						<p class="text_title text_title1" style="color:#222;font-size: 18px;">{{ item.Title }}</p>
						<p style="font-size: 14px;color: #999;">{{ formatDate(item.ReleaseDate) }}</p>
						<p class="text_view text_view1" style="color:#666;font-size:14px;">{{ item.Description }}</p>
					</div>
				</div>
			</div>
			<router-link to='/moreNews'>
				<div
					style="color:#222;margin-top:20px;font-size:16px;cursor: pointer;text-align: left;padding-left: 15px;text-align: center;">
					查看更多 <img width="12" src="../../static/img/media/next.png" /></div>
			</router-link>
		</div>

		<div class="media_database" id="title2">
			<h4 class="media_database_title" v-if="windowWidth >= 768">视频集锦</h4>
			<h4 class="text-left" style="padding-left: 10px;font-size: 20px !important;" v-else>视频集锦</h4>
			<ul class="product">
				<li v-for="(item, index) in newMediaList" :key="index" v-if="index < videoIndex">
					<div class="img-box">
						<div class="img-box-inner">
							<img @click="playVedio(nameId(index), index)" :src="splitImg(item.Cover)" alt="">
							<img @click="playVedio(nameId(index), index)" class="play_btn" width="40"
								src="../../static/img/service/ic_play.png" />
						</div>
					</div>
					<p class="videoTitle" style="padding:20px;">{{ item.Title }}</p>
					<div class="video_box" v-show="index == n">
						<video :id="nameId(index)" class="video_view" controls="controls">
							<source :src="item.MediaUrl" type="video/ogg">
							<source :src="item.MediaUrl" type="video/mp4">
							Your browser does not support the video tag.
						</video>
						<img class="stopBtn" width="50" height="50" src="../../static/img/index/ic_stop.png"
							@click.stop="stopPlay(nameId(index))" />
					</div>
				</li>
				<li @click="moreImg">
					<div class="img-box">
						<div class="img-box-inner">
							<img src="../../static/img/media/2.png" alt="">
							<div class="box">
								<span style="font-size:18px">查看全部</span>
								<span>共{{ newMediaList.length }}个视频</span>
							</div>
						</div>
					</div>
					<!-- <p>查看更多</p> -->
				</li>
			</ul>

		</div>

	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import Vue from 'vue';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
// import api from '../api/api.js';
Vue.use(Viewer);
Viewer.setDefaults({
	Options: {
		inline: true,
		button: true,
		navbar: true,
		title: true,
		toolbar: true,
		tooltip: true,
		movable: true,
		zoomable: true,
		rotatable: true,
		scalable: true,
		transition: true,
		fullscreen: true,
		keyboard: true,
		url: 'data-source',
	},
});
import cxHead from '@/components/cx-head.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		cxHead,
	},
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: 'keyWords',
					content: this.SeoKeyword,
				},
				{
					name: 'description',
					content: this.SeoDescription,
				},
			],
		};
	},
	data() {
		//这里存放数据
		return {
			windowWidth: window.innerWidth,
			loading: true,
			pageName: '',
			SeoKeyword: '',
			SeoDescription: '',
			i: 0,
			n: -1,
			type: 'audio',
			newsList: [],
			mianbaoList: [
				{
					label: '图文展示',
					path: '#',
					id: '#title1',
				},
				{
					label: '视频集锦',
					path: '#',
					id: '#title2',
				},
			],
			newMediaList: [],
			imgList: [],
			videoIndex: window.innerWidth < 768 ? 9 : 8
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		gotoPage() {
			this.$router.push({
				path: '/activity'
			});
		},
		splitImg(imgStr) {
			if (imgStr) {
				let imgList = imgStr.split(',');
				return imgList[0]
			} else {
				return ''
			}
		},
		formatDate(date) { //格式化日期
			if (date) {
				let date1 = new Date(date.replace(/-/g, '/'));
				date = this.common.formatDate(new Date(date1), 'yyyy年MM月dd日');
			}
			return date;
		},
		getSiteData() {
			//获取seo关键字
			let that = this;
			that.$axios
				.post(api.GetSiteData, {})
				.then(function (response) {
					// console.log('seo优化', response);
					let data = response.data;
					that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
					that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
					that.SeoDescription = data.SeoDescription
						? data.SeoDescription
						: '约你游·一站式房车旅游综合服务平台';
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		goAnchor(selector, index) {
			this.i = index;
			//跳转锚点
			var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id
			document.body.scrollTop = anchor.offsetTop; // chrome
			document.documentElement.scrollTop = anchor.offsetTop; // firefox
		},

		gotoDetail(item) {
			this.$router.push({
				path: '/newsText',
				query: { title: item.Title, date: item.CreateDate, textHtml: item.Content },
			});
		},
		getMediaPageData() {
			let that = this;
			this.$axios
				.post(api.GetMediaPageData, {
					page: 1,
					rows: 10,
					wheres: "[{ name: 'MediaType', value:'2' }]",
					sort: 'IsTop,Sort,CreateDate'
				})
				.then(function (response) {
					console.log('新闻', response);
					that.loading = false;
					that.newsList = response.data.rows;
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		getMedia() {
			let that = this;
			that.$axios
				.post(api.GetMediaPageData, {
					wheres: "[{ name: 'MediaType', value:'1' }]",
					sort: 'IsTop,Sort,CreateDate'
				})
				.then(function (response) {
					console.log('媒体', response.data);
					let data = response.data.rows;
					that.newMediaList = data;
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		// getImgList() {
		// 	let that = this;
		// 	that.type = 'img';
		// 	that.$axios
		// 		.post(api.GetMediaPageData, {
		// 			wheres: "[{ name: 'MediaType', value:'2' }]",
		// 		})
		// 		.then(function (response) {
		// 			let data = response.data.rows;
		// 			// that.imgList = data;
		// 			let imgStr = '';
		// 			for (let i = 0; i < data.length; i++) {
		// 				imgStr += data[i].MediaUrl + ',';
		// 			}
		// 			console.log('imgStr', imgStr);

		// 			let imgList = imgStr.split(',');
		// 			that.imgList = imgList.slice(0, imgList.length - 1);

		// 			console.log('imgList', that.imgList);
		// 		})
		// 		.catch(function (error) {
		// 			console.log(error);
		// 		});
		// },

		nameId(index) {
			return 'id' + index;
		},
		playVedio(id, index) {
			// console.log(id)
			this.n = index;
			// this.mp4 = '../../static/mp4/2.mp4';
			// this.$set(this.mp4, 0, '../../static/mp4/2.mp4');
			var video = document.querySelector('#' + id);
			video.play();
		},
		stopPlay(id) {
			// console.log(id)
			this.n = -1;
			// this.mp4 = '../../static/mp4/2.mp4'
			var video = document.querySelector('#' + id);
			video.pause();

		},

		gotoNews(id) {
			this.$router.push({
				path: '/imgFile',
				query: { id: id },
			});
		},

		moreImg() {
			if (this.type == 'audio') {
				this.$router.push('/mediaFile');
			}
			if (this.type == 'img') {
				this.$router.push('/imgFile');
			}
			if (this.type == 'img2') {
				this.$router.push('/event');
			}
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		// this.newMediaList = this.mediaList.filter(item => item.type === this.type)[0];
		// console.log('123', JSON.stringify(this.newMediaList));
		this.getMediaPageData();
		this.getMedia();
		// console.log('111111' + JSON.stringify(this.mediaList.filter(item => item.type === this.type)[0]));
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		this.getSiteData();
	},
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
	padding-bottom: 90px;
	background-color: #f1f1f1;
}

.container-fluid {
	padding-left: 0 !important;
	padding-right: 0 !important;
}

// .mianbao {
// 	display: flex;
// 	flex-direction: row;
// 	align-items: center;
// 	background: #fbfbfb;
// 	font-size: 14px;
// 	padding: 4px;
// }
.mianbao {
	// display: flex;
	// flex-direction: row;
	// align-items: center;
	background: #fbfbfb;
	font-size: 16px;
	padding-top: 15px;
}

.mianbao_view {
	width: 1250px;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
}


.date_month {
	color: #666666;
	font-size: 16px;
}

.state_view2 .media_right {
	// border-bottom: 1px solid #f0eeef;
	flex: 1;
	margin-right: 50px;
}

.media_right {
	text-align: start;
	flex: 1;
}

.box {
	background: rgba(255, 101, 55, 0.7);
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	align-items: center;
	display: flex;
	justify-content: center;
	color: #fff;
	flex-direction: column;
}

@media (min-width: 768px) {

	// .mianbao {
	// 	padding-left: 200px;
	// }
	.mianbao_min {
		display: none;
	}

	.top_img1 {
		display: none;
	}

	.top_img {
		display: block;
	}

	.video_box {
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		text-align: center;

		.stopBtn {
			position: absolute;
			right: 20px;
			top: 60px;
			z-index: 2;
		}
	}

	.video_view {
		width: 100%;
		height: 100%;
		// margin-top: 200px;
	}

	.state_view2 {
		margin-top: 40px;
	}

	.text_view1 {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 4;
		display: -webkit-box;
		-webkit-box-orient: vertical
	}
}

@media (max-width: 768px) {
	.fixed-top {
		background: transparent;
	}

	.mianbao_min {
		display: flex;
		height: 35px;
		line-height: 35px;
		background-color: #fbfbfb;
		padding-left: 15px;
	}

	.top_img {
		display: none;
	}

	.top_img1 {
		display: block;
	}

	.text_title {
		font-size: 16px;
		white-space: nowrap;
		overflow: hidden;
		width: calc(100vw - 100px) !important;
		text-overflow: ellipsis;
		margin-bottom: 2px;
	}

	.text_title1 {
		width: calc(100vw - 30px) !important;
	}

	.text_view {
		white-space: nowrap;
		overflow: hidden;
		width: calc(100vw - 100px) !important;
		text-overflow: ellipsis;
	}

	.text_view1 {
		width: calc(100vw - 60px) !important;
	}

	.title_view {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-right: 15px;

		.titie-right {
			color: #222;
			font-size: 12px;
		}
	}

	.more_btn1 {
		display: block;
	}

	.more_btn2 {
		display: none;
	}

	.mianbao_item {
		flex: 1;
	}

	.mianbao {
		display: none;
	}

	.title_text {
		color: #222;
		font-size: 20px;
		font-weight: bold;
		text-align: start;
		display: block !important;
		margin-top: 15px;
		margin-left: 10px;
	}



	.state_right {
		margin: 15px;
	}

	.media_left {
		display: none;
	}

	.media_database {
		margin-top: 30px !important;
	}

	.product {
		display: flex;
		list-style: none;
		// width: 1200px;
		flex-wrap: wrap;
		margin: 0 12px;
		margin-top: 10px;
		padding: inherit;
		justify-content: space-around;

		li {
			background-color: #fff;
			width: 49%;
			// padding: 0 10px;
			// margin: 0 15px;
			cursor: pointer;
			margin-top: 10px;

			.img-box {
				margin: 0 auto;
				padding: 4px;
				// height: 200px;
				// background-color: #cccccc;
				position: relative;

				.play_btn {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 30px;
					height: 30px;
					margin-top: -15px;
					margin-left: -15px;
				}

				.img-box-inner,
				img {
					width: 100%;
					height: 120px;
					overflow: hidden;
					transition: all 0.8s;
					position: relative;
				}
			}

			p {
				padding: 10px 0;
				margin-bottom: 0;

			}
		}
	}


	.video_box {
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.video_view {
		width: 100%;
		margin-top: 50%;
		height: 50%;
	}

	.stopBtn {
		position: absolute;
		right: 20px;
		top: 60px;
		z-index: 2;
	}

	.videoTitle {
		white-space: nowrap;
		overflow: hidden;
		width: calc(50vw - 10px) !important;
		text-overflow: ellipsis;
		text-align: left;
	}
}

.title_text {
	display: none;
}

.mianbao_item {
	margin: 0 20px;
	padding-bottom: 15px;
	cursor: pointer;
}

.active {
	// font-weight: bold;
	border-bottom: 2px solid #0C8C69
}

.media_view {
	display: flex;
	flex-direction: row;
	// border-bottom: 1px solid #f0eeef;
	// padding-bottom: 20px;
	background-color: #fff;
}

.state_view2 .media_view {
	border: none;
}

.state_right {
	cursor: pointer;
}

.media_database {
	max-width: 1080px;
	width: 100%;
	margin: 0 auto;
	margin-top: 60px;

}

@media (min-width: 768px) {
	.more_btn1 {
		display: none;
	}

	.more_btn2 {
		display: block;
		text-align: left;
		color: #222;
		font-size: 24px;
	}

	.media_state {
		margin: 40px auto;
		font-size: 14px;
		width: 100%;
		max-width: 1080px;
	}

	.media_view {
		// padding-bottom: 20px;
		margin-top: 40px;
	}

	.state_view1 {
		display: flex;
		flex-direction: row;
		margin-top: 50px;
		cursor: pointer;
	}



	.state_view1 .state_right {
		margin-left: 40px;
		flex: 1;
	}

	.media_database_title {
		text-align: left;
		font-size: 30px;
		color: #222;
	}


	.product {
		display: flex;
		list-style: none;
		max-width: 1080px;
		width: 100%;
		flex-wrap: wrap;
		margin: 0 auto;
		margin-top: 40px;
		padding: inherit;

		li {
			background-color: #fff;
			width: 340px;
			// padding: 0 5px;
			// margin: 0 15px;
			margin-right: 20px;
			cursor: pointer;
			margin-bottom: 22px;
			text-align: left;
			font-size: 20px;
			color: #222;

			.img-box {
				margin: 0 auto;
				// padding: 4px;
				// height: 200px;
				// background-color: #cccccc;
				position: relative;

				.play_btn {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 40px;
					height: 40px;
					margin-top: -20px;
					margin-left: -20px;
				}

				.img-box-inner,
				img {
					width: 100%;
					height: 220px;
					overflow: hidden;
					transition: all 0.8s;
					position: relative;
				}
			}

			p {
				padding: 10px 0;
				margin-bottom: 0;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}

			&:hover {
				.img-box {
					background-color: #fff;

					img {
						transform: scale(1.2);
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/page/media.vue